import { createAction } from "typesafe-actions";

const NAMESPACE = "si/quota";

export const setDataCostVisibility = createAction(`@@${NAMESPACE}/set-data-cost-visibility`)<boolean>();
export const toggleDataCostVisibility = createAction(`@@${NAMESPACE}/toggle-data-cost-visibility`)();
export const setDataCreditsModalOpen = createAction(`@@${NAMESPACE}/set-data-credits-modal-open`)<boolean>();
export const setQuotaContactAdminModalOpen = createAction(
    `@@${NAMESPACE}/set-quota-contact-admin-modal-open`,
)<boolean>();
